import React from 'react';

function Copyright(){
	
	return(
		<div className="grid-x copyright bt1-ccc bb1-ccc ptb-20 mlr-10 bg-eee">
			<div className="large-12 medium-12 small-12 cell text-center">
					<div className="font-source-sans font-size-14 font-weight-600 txt-dark-blue">SferoHub.com</div>
					<div className="font-source-sans font-size-14 font-weight-600 txt-dark-blue italic pt-5">Your World, Synced</div>
					<div className="font-source-sans font-size-14 font-weight-500 txt-333 uppercase pt-5">&copy;&nbsp;2023-2026</div>
					<div className="font-source-sans font-size-14 font-weight-400 txt-333  pt-20">Update: 12/15/2025</div>
			</div>
		</div>
	);
	
}

export default Copyright;